import { salesChannelRoutes } from 'src/tools/urlMap';

export const controlledPath = [
  salesChannelRoutes.productList,
  salesChannelRoutes.promotionTagList,
  salesChannelRoutes.promotionTagDetail,
  salesChannelRoutes.salesChannelProductsLinkProductDetail,
  salesChannelRoutes.collectionList,
  salesChannelRoutes.collectionDetail,
  salesChannelRoutes.categoryProducts,
  salesChannelRoutes.directDiscountList,
  salesChannelRoutes.directDiscountDetail,
  salesChannelRoutes.subscriptionBuyList,
  salesChannelRoutes.subscriptionBuyDetail,
  salesChannelRoutes.giftPurchaseList,
  salesChannelRoutes.giftPurchaseList,
  salesChannelRoutes.giftPurchaseDetail,
  salesChannelRoutes.flashSalesList,
  salesChannelRoutes.flashSalesDetail,
  salesChannelRoutes.voucherList,
  salesChannelRoutes.voucherDetail,
  salesChannelRoutes.invoiceSetting,
  salesChannelRoutes.currencySetting,
  salesChannelRoutes.logisticsSetting,
  salesChannelRoutes.inventorySetting,
  salesChannelRoutes.orderSetting,
  salesChannelRoutes.paymentSetting,
  salesChannelRoutes.checkoutSetting,
  salesChannelRoutes.taxSetting,
  salesChannelRoutes.communicationSetting,
  salesChannelRoutes.communicationTemplate,
  salesChannelRoutes.salesChannelEditorAllProductPage,
  salesChannelRoutes.salesChannelEditorShoppingCartPage,
  salesChannelRoutes.salesChannelEditorProfilePage,
  salesChannelRoutes.salesChannelEditorProductSearch,
];
